module.exports = __webpack_public_path__ + "static/img/aomasen.74477862.jpg";